import React, {useState} from "react";
import PropTypes from "prop-types";

import CountryFlag from "../../components/CountryFlag";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";


const languageOptions = [
    {code: "IT", flagElement: <CountryFlag code="IT"/>, name: "Italiano"},
    {code: "EN", flagElement: <CountryFlag code="GB"/>, name: "Inglese"},
];

const defaultOption = languageOptions[0];

const LanguageSelect = (props) => {
    const { onSelection, initialValue=defaultOption} = props;
    const [selected, setSelected] = useState(initialValue);

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const menuOpen = Boolean(menuAnchorEl);

    const handleOpen = (e) => {
        setMenuAnchorEl(e.currentTarget);
    }

    const handleSelect = (option) => {
        handleClose();
        setSelected(option);
        onSelection(option.code);
    }

    const handleClose = () => {
        setMenuAnchorEl(null);
    }

    return <>
        <Button
            id="language-select-button"
            aria-controls={menuOpen ? 'language-select-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? 'true' : undefined}
            onClick={handleOpen}
            color="inherit"
            endIcon={<ArrowDropDownIcon/>}
            sx={{p:0}}
        >
            { selected.flagElement}
        </Button>

        <Menu
            id="top-bar-select-menu"
            anchorEl={menuAnchorEl}
            open={menuOpen}
            onClose={handleClose}
            MenuListProps={{'aria-labelledby': 'top-bar-select-button'}}>
            {
                languageOptions.map(l =>
                    <MenuItem key={l.code} value={l.code}  onClick={() => handleSelect(l)}>
                        {l.flagElement}&nbsp;{l.name}
                    </MenuItem>
                )
            }
        </Menu>
    </>
}


LanguageSelect.propTypes = {
    onSelection: PropTypes.func.isRequired, // function called when a selection is clicked (the selected option is passed as argument)
    selected: PropTypes.string,  // initial selected value
}

export default LanguageSelect;